module.exports = __webpack_public_path__ + "img/license_not_allow.6d55dadb.svg";